import moment from 'moment';
import timezone from 'moment-timezone';
// Get current user time zone
const USER_TIMEZONE = timezone.tz.guess() || 'America/New_York';

const formatTableDate = (date, type) => {
  let FORMAT = 'MMM D';

  if (type && type === 'utc') {
    return moment.utc(date).format(FORMAT);
  }
  return timezone(date)
    .tz(USER_TIMEZONE)
    .format(FORMAT);
};

export default formatTableDate;



// WEBPACK FOOTER //
// ./src/lib/helpers/GeneralHelpers/formatTableDate.js